import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getRoomReservations({ commit }, payload = {
        query: ''
    } ) {
        return axios
            .get(`/reservations/room-reservations${payload.query}`)
            .then(response => {
                commit('GET_ROOM_RESERVATIONS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie rezerwacji nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getRoomReservation(context, roomReservationId) {
        return axios
            .get(`/reservations/room-reservations/${roomReservationId}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, `Pobranie danych do rezerwacji ${roomReservationId} nie powiodło się.`)

                return Promise.reject(error)
            })
    },
    saveRoomReservation({ commit }, roomReservationData) {
        return axios
            .post('/reservations/room-reservations', roomReservationData)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Rezerwacja została dodana.'
                }, {root: true})

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie rezerwacji nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateRoomReservation({ commit }, roomReservationData) {
        return axios
            .put(`/reservations/room-reservations/${roomReservationData.id}`, roomReservationData)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Rezerwacja została zedytowana.'
                }, {root: true})

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Edycja rezerwacji nie powiodła się.')

                return Promise.reject(error)
            })
    },
    deleteRoomReservation({ commit }, roomReservationData) {
        return axios
            .delete(`/reservations/room-reservations/${roomReservationData.id}`, roomReservationData)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Rezerwacja została usunięta.'
                }, {root: true})

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Usunięcie rezerwacji nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getRoomReservationsStatuses({ commit }) {
        return axios
            .get('/reservations/room-reservations/dicts/reservation-status')
            .then(response => {
                commit('GET_ROOM_RESERVATIONS_STATUSES_SUCCESS', response.data.results)

                return Promise.resolve(response.data)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie statusów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getRoomReservationsTypes({ commit }) {
        return axios
            .get('/reservations/dicts/room-type')
            .then(response => {
                commit('GET_ROOM_RESERVATIONS_TYPES_SUCCESS', response.data.results)

                return Promise.resolve(response.data)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie salek nie powiodło się.')

                return Promise.reject(error)
            })
    },
    clearRoomReservations({ commit }) {
        commit('CLEAR_ROOM_RESERVATIONS')
    },
}